module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/024-honduras-cd729170081cb16caa804e367250d828.svg";